<template>
<div>

  <Button @click="" style="float: right" type="primary" @click="openGalleryForm">Upload Image</Button>

  <h4>You can rearrange the slides using Drag and Drop.</h4>
  <span style="color:lightslategrey">Click on the slide that you want to rearrange and use the "drag" option of
                    your mouse to place it in whatever order you want.</span>

  <Row :gutter="15">
    <draggable @end="drag=false;updateSequence()" @start="drag=true" class="row q-col-gutter-md"
               group="people" v-model="galleryImages">
        <Col span="8" v-for="(gallery,index) in galleryImages" :key="index">
          <Card shadow class="cardStyle">
            <div class="image-box">
              <div class="image-box-content">
              <img :src="gallery.imageUrl" height="190" style="width: 100%">
              <div class="caption">{{gallery.caption?gallery.caption:'No Caption'}}</div>
              </div>
              <div class="image-box-option">
                <i class="fas fa-pencil-alt" title="Edit Image" @click="onEditGalleryImage(gallery)"></i>
                <i class="fas fa-trash" title="Delete Image" @click="onDeleteGalleryImage(gallery.id)"></i>
              </div>
            </div>
          </Card>
        </Col>
    </draggable>
  </Row>


  <gallery-form ref="gallery-form-comp" :galleryImages="galleryImages"></gallery-form>

</div>
</template>

<script>
import GalleryForm from "./GalleryForm";
import {SUBSCRIBE_GALLERY_IMAGE} from "../graphql/subscription/gallery";
import {ADD_GALLERY_IMAGE, DELETE_GALLERY, DELETE_GALLERY_IMAGE} from "../graphql/mutations/gallery";
import draggable from 'vuedraggable'
import {generateUUID} from "../Constants/Constant";
import moment from "moment";
    export default {
      name: "Gallery",
      components: {GalleryForm, draggable},
      apollo: {
        $subscribe: {
          gallery: {
            query: SUBSCRIBE_GALLERY_IMAGE,
            result ({ data }) {
              this.galleryImages = data.gallery;
            },
           }
          }
        },
      data: function() {
        return {
          galleryFormDrawer: false,
          galleryImages: [],
        }
      },
      methods: {
        openGalleryForm(){
          this.galleryFormDrawer = true
        },
        onEditGalleryImage(row){
          this.$refs['gallery-form-comp'].setGalleryForm(row);
          this.galleryFormDrawer = true;
        },
        async updateSequence () {
          let self = this
          let response = await self.$apollo.mutate({
            mutation: DELETE_GALLERY,
          })
          if (response.data) {
            self.galleryImages.forEach((image, sequenceNo) => {
              delete image.__typename;
              self.$apollo.mutate({
                mutation: ADD_GALLERY_IMAGE,
                variables: {
                  object: {
                    ...image,
                    ...{
                      id: generateUUID(),
                      sequenceNo: sequenceNo,
                    }
                  }
                },
              })
            })
          }
        },
        onDeleteGalleryImage(galleryImageId){
          this.$Modal.confirm({
            title: 'Confirmation',
            content: '<p>Are You sure want to delete Gallery Image ?</p>',
            loading: true,
            onOk: () => {
              this.deleteGalleryImage(galleryImageId, this.$Modal)
            }
          });
        },
        deleteGalleryImage(galleryImageId, callback){
          this.$apollo.mutate({
            mutation: DELETE_GALLERY_IMAGE,
            variables: { id: galleryImageId }
          }).then(function(response){
            callback.remove();
            this.$Message.success('Gallery Image deleted successfully!');
          }).catch(function(err){
            callback.remove();
          })
        }
      }
    }
</script>

<style scoped>
  .cardStyle{
    background: #fff !important;
    border-radius: 10px;
    box-shadow: 0px 2px 5px -3px;
    position: relative;
  }
  .cardStyle:hover{
    box-shadow: 0px 2px 7px -2px !important;
  }
  .gallery-action-item{
    float: right;
    margin: -20px 0 0 0;
    font-size: 15px;
    cursor: pointer;
  }
  /*.fa-pencil-alt{*/
  /*  margin-right: 15px;*/
  /*  color: grey;*/
  /*}*/
  /*.fa-trash{*/
  /*  color: red;*/
  /*}*/
</style>
<style>
  .image-box {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #f1f1f1;
    min-height: 10.8125rem;
    background: #fff;
  }
  .image-box:hover {
    box-shadow: 0 10px 25px rgba(207, 207, 207, .3);
    transition: all ease-in 0.3s;
  }
  .image-box:hover .image-box-option {
    transform: translateY(0);
    transition: transform ease 0.3s;
  }
  .image-box:hover .image-box-option .fa-trash {
    transform: translateY(0);
    transition: transform cubic-bezier(0.68, -0.55, 0.27, 1.55) 0.6s;
  }
  .image-box:hover .image-box-option .fa-pencil-alt {
    transform: translateY(0);
    transition: transform cubic-bezier(0.68, -0.55, 0.27, 1.55) 1s;
  }
  .image-box .image-box-content {
    position: relative;
  }
  .image-box .image-box-content .caption {
    width: 100%;
    display: initial;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 600;
    font-size: 14px;
  }
  .image-box .image-box-option {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    transform: translateY(50px);
    transition: transform ease 0.2s;
    display: block;
    padding: 12px;
  }
  .image-box .image-box-option .fa-trash {
    width: 2.1875rem;
    height: 2.1875rem;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: inline-flex;
    transform: translateY(15px);
    background: #fef6ed;
    margin-left: 5px;
    color: red;
  }
  .image-box .image-box-option .fa-pencil-alt {
    width: 2.1875rem;
    height: 2.1875rem;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    display: inline-flex;
    transform: translateY(15px);
    background: #ebf6f5;
  }

</style>
